import { AxiosResponse } from 'axios';
import { doorClient, ImResponse, resolve } from 'services/api';

type PageResponse<T> = {
  page: Knowledge.Pagination & { total: number };
  data: T;
};

function pageResponseResolve<T>(promise: Promise<AxiosResponse<PageResponse<T>>>) {
  return promise.then((response) => {
    return response.data;
  });
}

export const queryByKnowledge = (data: { knowledgeName: string; page: Knowledge.Pagination }) => {
  return pageResponseResolve(
    doorClient.post<PageResponse<Knowledge.SPU.Knowledge[]>>(
      '/knowledge/spu_knowledges/v2/query_by_knowledge',
      data,
    ),
  );
};

export const queryBySpu = (data: {
  spus: Partial<Knowledge.SPU.SpuInfo>[];
  page: Knowledge.Pagination;
  keywordType: Knowledge.SPU.SpuKeywordType;
  searchKeyword: string;
}) => {
  return pageResponseResolve(
    doorClient.post<PageResponse<Knowledge.SPU.SpuWithKnowledges[]>>(
      '/knowledge/spu_knowledges/v2/query_by_spu',
      data,
    ),
  );
};

export const createKnowledge = (data: { spuKnowledge: Knowledge.SPU.KnowledgeFormValue }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/v2/create', data));
};

export const updateKnowledge = (data: { spuKnowledge: Knowledge.SPU.Knowledge }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/v2/update', data));
};

export const updateKnowledgeBySpu = (data: { spuKnowledge: Knowledge.SPU.Knowledge }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/v2/update_by_spu', data));
};

export const deleteKnowledge = (data: { knowledgeId: number }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/delete', data));
};

export const deleteSpuMapping = (data: { knowledgeId: number; spu: Knowledge.SPU.SpuInfo }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/delete_spu_mapping', data));
};

export const updateKnowledgeV3 = (data: { spuKnowledge: Knowledge.SPU.Knowledge }) => {
  return resolve<unknown>(doorClient.post('/knowledge/spu_knowledges/v3/update', data));
};

/************************* 标签管理 start **************************/
type TagSpu = {
  spuId: string;
  spuImage: string;
  spuName: string;
};
type TagData = {
  tagId: string;
  tagName: string;
  tagCreateTimeMs: string;
  tagUpdateTimeMs: string;
  tagSpuData: TagSpu[];
  spuCount: string;
};
type TagResponse = {
  tagData: TagData[];
  pageInfo: {
    pageSize: number;
    pageNo: number;
    hasNext: boolean;
    totalCount: number;
  };
};

export const defaultTagResponse: () => TagResponse = () => {
  return {
    tagData: [],
    pageInfo: {
      pageSize: 10,
      pageNo: 1,
      hasNext: false,
      totalCount: 0,
    },
  };
};

// 列表
export const querySpuLabel = (data: {
  tagName: string;
  pageInfo: {
    pageSize: number;
    pageNo: number;
  };
}) => {
  return resolve(doorClient.post<ImResponse<TagResponse>>('/item/v1/tag/list', data));
};

// 新增和更新
export const mutateSpuLabel = (data: {
  tagId?: string;
  tagName?: string;
  operateType: 1 | 2; // 1: 覆盖更新 2: 追加更新
  tagIndexData: Knowledge.SPU.TagIndexData[];
}) => {
  return doorClient.post('/item/v1/tag/update', data);
};

// 删除
export const deleteSpuLabel = (data: { tagId: string }) => {
  return doorClient.delete('/item/v1/tag', { data: data });
};

// 获取标签详情，也可用于判断标签是否存在
export const getTag = (data: { tagId?: string; tagName?: string }) => {
  return resolve(
    doorClient.post<ImResponse<TagData>>(
      '/item/v1/tag/get',
      Object.assign({}, data, {
        pageInfo: {
          pageSize: 9999,
          pageNo: 1,
        },
      }),
    ),
  );
};
/************************* 标签管理 end **************************/
